import { api } from './client.js';

export const fetchApprovalConfig = () => api.get('/settings/approval').then((r) => r.data);
export const saveApprovalConfig = (body) => api.put('/settings/approval', body).then((r) => r.data);

// Invoice-email template used by the one-click "Send invoice" action.
export const fetchInvoiceEmail = () => api.get('/settings/invoice-email').then((r) => r.data);
export const saveInvoiceEmail = (body) => api.put('/settings/invoice-email', body).then((r) => r.data);

// Client-invite email template (message clients get when invited to set up their login).
export const fetchClientInvite = () => api.get('/settings/client-invite').then((r) => r.data);
export const saveClientInvite = (body) => api.put('/settings/client-invite', body).then((r) => r.data);

// Minimum order value per store (enforced in the New Order flow).
export const fetchMinOrder = () => api.get('/settings/min-order').then((r) => r.data);
export const saveMinOrder = (body) => api.put('/settings/min-order', body).then((r) => r.data);

// Automatic customer lifecycle emails (discount announcement + post-delivery follow-up).
export const fetchCustomerMessages = () => api.get('/settings/customer-messages').then((r) => r.data);
export const saveCustomerMessages = (body) => api.put('/settings/customer-messages', body).then((r) => r.data);

export const fetchRemittance = () => api.get('/settings/remittance').then((r) => r.data);
export const saveRemittance = (body) => api.put('/settings/remittance', body).then((r) => r.data);

// Catalog sync from both Shopify stores (companies/locations + product cache refresh). GET returns
// the last-run summary (or null); POST runs it now (admin only).
export const fetchLastSync = () => api.get('/settings/sync-catalog').then((r) => r.data);
export const runCatalogSync = () => api.post('/settings/sync-catalog').then((r) => r.data);
// Durable catalog snapshot coverage/freshness (how many locations are stored in the DB + refresh times).
export const fetchCatalogSnapshots = () => api.get('/settings/catalog-snapshots').then((r) => r.data);

// The client home page's sections (which show, in what order).
export const fetchClientHomeLayout = () => api.get('/settings/client-home').then((r) => r.data);
export const saveClientHomeLayout = (sections) => api.put('/settings/client-home', { sections }).then((r) => r.data);
